import * as React from 'react';
import { Form, Input, Button, Select, Divider, message, Spin, Checkbox, Tooltip, Row, Col } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { Link } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import SVGComponent, { FilterType } from '../../components/common/SVGComponent';

const logo = require('src/assets/branding/logo.png');

import ForgotPasswordDTO from 'src/models/account/ForgotPasswordDTO';
import AccountApiController from 'src/api/AccountApiController';

interface ForgotPasswordProps extends PageProps<{}>, FormComponentProps, LocalizeContextProps { }

interface ForgotPasswordState {
    isSubmitting: boolean;
}

class ForgotPassword extends React.Component<ForgotPasswordProps, ForgotPasswordState> {
    constructor(props: ForgotPasswordProps) {
        super(props);
        bindAllOfThis(this, ForgotPassword.prototype);

        this.state = {
            isSubmitting: false
        };
    }

    private handleSubmit(e): void {
        e.preventDefault();

        this.props.form.validateFields((error: any, values: any) => {
            if (!error) {
                this.setState({
                    isSubmitting: true
                });

                AccountApiController.sendForgotPasswordEmail(values).then(result => {

                    this.setState({
                        isSubmitting: false
                    });

                    message.success(this.props.translate('account.forgotPassword.messageSend'));
                    this.props.history.push(Routes.LOGIN);
                });
            }
        });
    }

    private renderForm() {
        return <Form hideRequiredMark onSubmit={this.handleSubmit}>
            <h3>{this.props.translate('account.forgotPassword.header')}</h3>
            <Form.Item>
                {
                    this.props.form.getFieldDecorator('email',
                        {
                            rules: [
                                { required: true, message: this.props.translate("admin.common.requiredRule").toString() },
                                { type: 'email', message: this.props.translate("admin.common.emailRule").toString() }
                            ]
                        })
                        (<Input size="large" placeholder={this.props.translate("account.forgotPassword.formItem1").toString()} type="email" />)
                }
            </Form.Item>
            <Form.Item>
                <Button className="ant-btn ant-btn-lg" loading={this.state.isSubmitting} htmlType="submit">
                    {
                        !this.state.isSubmitting && this.props.translate("account.forgotPassword.button1")
                    }
                </Button>
            </Form.Item>
            <Form.Item>
                <Link to={Routes.LOGIN}>
                    <Button className="ant-btn ant-btn-lg">
                        <Translate id="account.forgotPassword.button2" />
                    </Button>
                </Link>
            </Form.Item>
        </Form>;
    }

    render() {
        return <div>
            <Row type="flex" justify="center">
                <Col xs={22} sm={22} md={18} lg={14} xl={11} className="login-form">
                    <Link to={Routes.BASE_ROUTE} className="logo">
                        <img src={logo} alt="Kuder Galaxy" />
                    </Link>
                    {this.renderForm()}
                </Col>
            </Row>
        </div>;
    }
}

export default withLocalize(Form.create()(ForgotPassword));



// WEBPACK FOOTER //
// ./src/pages/account/ForgotPassword.tsx